exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".information.document .details .item .type {\n  flex: 1;\n}\n.information.document .blockchain {\n  background: rgba(255, 255, 255, 0.1);\n  padding-bottom: 15px;\n}\n.information.document .blockchain .item {\n  margin-top: 15px;\n  padding: 0 10px;\n}", ""]);

// exports
